export default {
  namespaced: true,
  billing: {
    title: "Facturación",
  }
}